import React, { Fragment } from "react"

const rating = reviews => {
  if (reviews.length === 0) return 0
  const rates = reviews.reduce((acc, item) => acc + item.rate, 0)
  const num = rates / reviews.length
  return Math.round(num * 100) / 100
}

const MicroFormat = props => {
  const {
    title,
    description,
    reviews,
    url,
    image,
    map_lat,
    map_lng,
    lang
  } = props

  const TouristAttraction = {
    "@context": "http://schema.org/",
    "@type": "TouristAttraction",
    name: title,
    description: description,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: rating(reviews.nodes),
      bestRating: 5,
      worstRating: 0,
      ratingCount: reviews.pageInfo.total
    }
  }

  const Place = {
    "@context": "http://schema.org/",
    "@type": "Place",
    name: title,
    description: description,
    url: `https://planetyze.com/${lang}${url}`,
    image: image ? image.url : "",
    geo: {
      "@type": "GeoCoordinates",
      latitude: map_lat,
      longitude: map_lng
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: rating(reviews.nodes),
      bestRating: 5,
      worstRating: 0,
      ratingCount: reviews.pageInfo.total
    }
  }

  return (
    <Fragment>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(TouristAttraction)
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(Place)
        }}
      />
    </Fragment>
  )
}

export default MicroFormat
